import * as React from "react";
export default React.memo(function SvgArrowLineLeft(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={57} height={38} role="presentation" {...props}><path fill="#999" d="M9.01 4.247C40.574 5.992 56.48 16.9 56.48 36.98v.5h-1v-.5c0-19.429-15.417-30.009-46.496-31.732l-.11 3.985L0 4.486 9.12.236z" /></svg>;
});